/**
 * @file   src\components\ThemeHelpModal.tsx
 * @brief  Help Modal component.
 * @date   Jun, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import { Modal, Button } from '../utils/thirdpartyComponents';
import '../components/CWModal.scss';
import Defaulthemeimg from '../assets/images/default-theme.svg';
import Customethemeimg from '../assets/images/custom-theme.svg';

// Toast object creation.

const ThemeHelpModal = (props: any) => {
const { show, onHide } = props;

const handleOnHide = () => {
    onHide();
}
  
  return (
      <Modal show={show} onHide={handleOnHide} centered className='theme-modal'>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div className="theme-content mx-auto">
              <div className="title-sec text-center">
                <h4 className='f-bold'>Theme Help Center</h4>
                <p className='f-medium'>Instructions to set up your own theme seamlessly.</p>
              </div>
              <div className="note">
                <div className="inner-wrap mx-auto">
                  <p className="title f-bold">Note</p>
                  <ul>
                    <li className='f-medium'>The default theme of the app uses the colors of the Car Wash logo. To aid in brand recall, 
                      you could switch to a color theme that closely matches your logo.</li>
                      <li className='f-medium'>We will use <span className='color'></span> White (#ffffff) as the default background for all the themes which will not be editable.</li>
                  </ul>
                </div>
              </div>
              <div className="theme-info">
                <div className="inner-wrap mx-auto">
                  <p className="title f-bold">Default Theme</p>
                  <div className="theme-details d-flex align-items-center justify-content-between">
                    <div className="theme-screen"><img src={Defaulthemeimg} alt="Car Wash App" /></div>
                    <div className="theme-colors">
                      <div className="color-info d-flex align-items-center">
                        <div className="color primary"></div>
                        <div className="content">
                          <p className="title f-bold">Primary</p>
                          <p>Header Background, Footer Active Tab, Secondary Button, Link Button</p>
                        </div>
                      </div>
                      <div className="color-info d-flex align-items-center">
                        <div className="color secondary"></div>
                        <div className="content">
                          <p className="title f-bold">Secondary</p>
                          <p>Tab Background, Scan Background</p>
                        </div>
                      </div>
                      <div className="color-info d-flex align-items-center">
                        <div className="color b-primary"></div>
                        <div className="content">
                          <p className="title f-bold">Button Primary</p>
                          <p>Primary Button, QR Border, Tab Active Border</p>
                        </div>
                      </div>
                      <div className="color-info d-flex align-items-center">
                        <div className="color secondary"></div>
                        <div className="content">
                          <p className="title f-bold">Button Text</p>
                          <p>Button text</p>
                        </div>
                      </div>
                      <div className="color-info d-flex align-items-center">
                        <div className="color t-primary"></div>
                        <div className="content">
                          <p className="title f-bold">Text Primary</p>
                          <p>Text</p>
                        </div>
                      </div>
                      <div className="color-info d-flex align-items-center">
                        <div className="color default"></div>
                        <div className="content">
                          <p className="title f-bold">Default</p>
                          <p>Main Background, Header Text</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="theme-info custom-theme">
                <div className="inner-wrap mx-auto">
                  <p className="title f-bold">Default Theme</p>
                  <div className="theme-details d-flex align-items-center justify-content-between">
                    <div className="theme-screen"><img src={Customethemeimg} alt="Car Wash App" /></div>
                    <div className="theme-colors">
                      <div className="color-info d-flex align-items-center">
                        <div className="color c-primary"></div>
                        <div className="content">
                          <p className="title f-bold">Primary</p>
                          <p>Header Background, Footer Active Tab, Secondary Button, Link Button</p>
                        </div>
                      </div>
                      <div className="color-info d-flex align-items-center">
                        <div className="color c-secondary"></div>
                        <div className="content">
                          <p className="title f-bold">Secondary</p>
                          <p>Tab Background, Scan Background</p>
                        </div>
                      </div>
                      <div className="color-info d-flex align-items-center">
                        <div className="color c-b-primary"></div>
                        <div className="content">
                          <p className="title f-bold">Button Primary</p>
                          <p>Primary Button, QR Border, Tab Active Border</p>
                        </div>
                      </div>
                      <div className="color-info d-flex align-items-center">
                        <div className="color c-b-text"></div>
                        <div className="content">
                          <p className="title f-bold">Button Text</p>
                          <p>Button text</p>
                        </div>
                      </div>
                      <div className="color-info d-flex align-items-center">
                        <div className="color t-primary"></div>
                        <div className="content">
                          <p className="title f-bold">Text Primary</p>
                          <p>Text</p>
                        </div>
                      </div>
                      <div className="color-info d-flex align-items-center">
                        <div className="color default"></div>
                        <div className="content">
                          <p className="title f-bold">Default</p>
                          <p>Main Background, Header Text</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
      </Modal>
  );
};
export default ThemeHelpModal;
